
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manifesto",
      function () {
        return require("private-next-pages/manifesto.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manifesto"])
      });
    }
  